// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: is this the Rail window? The Rail runs the app at /rail in its own small
// window and never navigates itself, so shared code that would move the router
// (an Assistant source card, voice mode's "Go there", a brief's "Show me", the
// floating voice dock) asks here first. No imports on purpose: widely shared
// components and their tests pull this in.

/** Routes.RAIL, spelled out so this file stays free of the app's runtime config. */
const RAIL_PATH = '/rail';
/** The class RailApp puts on <html> while the Rail is mounted. */
const RAIL_HTML_CLASS = 'konvo-rail';

export function isRailPath(pathname: string): boolean {
	return pathname === RAIL_PATH || pathname.startsWith(`${RAIL_PATH}/`);
}

/** True inside the Rail window. The path is known before RailApp mounts; the class covers previews. */
export function isRailWindow(): boolean {
	if (typeof window === 'undefined') return false;
	return isRailPath(window.location.pathname) || document.documentElement.classList.contains(RAIL_HTML_CLASS);
}
